import { createFileRoute, redirect } from "@tanstack/react-router"
import { z } from "zod/v4"

import { ResetPasswordPage } from "@/pages/(guest)/reset-password/page"

const resetPasswordSchema = z.object({
  token: z.string().min(1, "Token é obrigatório"),
})

export const Route = createFileRoute("/_guest/reset-password")({
  validateSearch: (search) => resetPasswordSchema.parse(search),
  beforeLoad: ({ search }) => {
    if (!search.token) {
      throw redirect({ to: "/" })
    }

    return null
  },
  component: ResetPasswordPage,
})
